import React from 'react';
import { useCurrentRooms, useGlobalContext } from '@honeycomb/data';
import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js';
import { Paper, Skeleton } from '@honeycomb/ui-core';
import { useShowPayPalPayInThreeMessage } from '../../hotel/utils/useShowPayPalPayInThreeMessage';
export function PayPalPayInThreeMessage(props) {
    var _a, _b, _c, _d, _e;
    const { priceToSplitInThree, currencyCode, logoType = 'primary', logoPosition = 'left', textColor, textSize = 14, textAlign, loading = false, } = props;
    const { currentContext, configSettings: { HcPayPalPayLaterClientId }, } = useGlobalContext();
    const [currentRooms] = useCurrentRooms();
    const show = useShowPayPalPayInThreeMessage();
    if (!show) {
        return null;
    }
    const currencyCodeCombined = currencyCode || currentContext.currencyCode || 'GBP';
    const { selectedRoomIndex = 0 } = ((_a = currentRooms.data) === null || _a === void 0 ? void 0 : _a.currentRooms) || {};
    const updatedRooms = (_c = (_b = currentRooms === null || currentRooms === void 0 ? void 0 : currentRooms.data) === null || _b === void 0 ? void 0 : _b.currentRooms) === null || _c === void 0 ? void 0 : _c.rooms;
    let price = '';
    price = ((_e = (updatedRooms && ((_d = updatedRooms[selectedRoomIndex]) === null || _d === void 0 ? void 0 : _d.price))) === null || _e === void 0 ? void 0 : _e.toString()) || priceToSplitInThree || '';
    if (updatedRooms && updatedRooms.length > 1) {
        price = updatedRooms === null || updatedRooms === void 0 ? void 0 : updatedRooms.reduce((acc, room) => acc + room.price, 0).toString();
    }
    const style = {
        layout: 'text',
        logo: {
            type: logoType,
            position: logoPosition,
        },
        text: {
            color: textColor,
            size: textSize,
            align: textAlign,
        },
    };
    const message = (React.createElement(PayPalMessages, { style: style, currency: currencyCodeCombined, amount: price, placement: "product", forceReRender: [style, currencyCodeCombined, price] }));
    return (React.createElement(PayPalScriptProvider, { options: {
            clientId: HcPayPalPayLaterClientId,
            components: 'messages',
        } }, loading ? (React.createElement(Skeleton, { radius: 10, h: 40 })) : (React.createElement(Paper, { radius: "s", px: 3, pt: 2, pb: 1, br: 5 }, message))));
}
